// extracted by mini-css-extract-plugin
var _1 = "TutorialModalButton__image--PABVg";
var _2 = "TutorialModalButton__imageColor--kqPjR";
var _3 = "TutorialModalButton__mainText--Eo0pR";
var _4 = "TutorialModalButton__text--N9sus";
export { _1 as "image", _2 as "imageColor", _3 as "mainText", _4 as "text" }
